import type { RichTextField } from "@sitecore-jss/sitecore-jss-nextjs";
import SCRichText from "commons/sc/SCRichText";

interface Fields {
    ContentText: RichTextField;
}

export type RichTextProps = {
    fields: Fields;
};

const RichText = (props: RichTextProps) => {
    if (!props.fields) return null;
    return <SCRichText richTextField={props.fields?.ContentText} />;
};
export default RichText;

export const Boxed = (props: RichTextProps) => {
    if (!props.fields) return null;
    return (
        <SCRichText
            richTextField={props.fields?.ContentText}
            backgroundColor={"brand.lighterGray"}
            p={{ base: "sp16", lg: "sp32" }}
            borderRadius={"base"}
        />
    );
};
